import { titleize } from 'inflection'

import {
  LAYER_AP,
  LAYER_AWS_STATUS,
  LAYER_CONN_GUIDANCE_MODE,
  LAYER_ERROR,
  LAYER_FW,
  LAYER_MIC,
  LAYER_NOISE,
  LAYER_OPERATIONAL_STATE,
  LAYER_PROVISION,
  LAYER_RESET_REASON,
  LAYER_RSSI,
  LAYER_SNOOZE,
  LAYER_SSID,
  LAYER_SSID_MIGRATION,
  LAYER_STATUS,
} from './components/LayerSelector'

const layerValueProps = {
  [LAYER_STATUS]: 'status',
  [LAYER_SNOOZE]: 'humanizedSnooze',
  [LAYER_AWS_STATUS]: 'awsStatus',
  [LAYER_PROVISION]: 'provision',
  [LAYER_OPERATIONAL_STATE]: 'operationalState',
  [LAYER_CONN_GUIDANCE_MODE]: 'connectivityGuidanceMode',
  [LAYER_RSSI]: 'humanizedRssi',
  [LAYER_AP]: 'ap',
  [LAYER_SSID]: 'ssid',
  [LAYER_SSID_MIGRATION]: 'ssidMigrationStatus',
  [LAYER_RESET_REASON]: 'resetReason',
  [LAYER_ERROR]: 'haveErrors',
  [LAYER_FW]: 'fw',
  [LAYER_NOISE]: 'noiseEnabled',
  [LAYER_MIC]: 'hasMicrophone',
}

const getLayerFormattedValue = ({ layer, unit, device }) => {
  let formattedValue = null

  switch (layer) {
    case LAYER_STATUS:
      formattedValue = titleize(unit.status)
      break
    case LAYER_SNOOZE:
      formattedValue = unit.humanizedSnooze
      break
    case LAYER_AWS_STATUS:
      formattedValue = titleize(device?.awsStatus || 'Unknown')
      break
    case LAYER_PROVISION:
      formattedValue = device?.provision ?? 'Unknown'
      break
    case LAYER_OPERATIONAL_STATE:
      formattedValue = device?.operationalState || 'Unknown'
      break
    case LAYER_CONN_GUIDANCE_MODE:
      formattedValue = device?.connectivityGuidanceMode || 'Unknown'
      break
    case LAYER_RSSI:
      formattedValue = device?.rssi ? parseInt(device?.rssi, 10) : 'Unknown'
      break
    case LAYER_AP:
      formattedValue = device?.ap || 'Unknown'
      break
    case LAYER_SSID:
      formattedValue = device?.ssid ?? 'Unknown'
      break
    case LAYER_SSID_MIGRATION:
      formattedValue = device?.ssidMigrationStatus ?? 'Unknown'
      break
    case LAYER_RESET_REASON:
      formattedValue = device?.resetReason ?? 'Unknown'
      break
    case LAYER_ERROR:
      formattedValue = device ? device?.errorConditions?.join(', ') || '--' : 'Unknown'
      break
    case LAYER_FW:
      formattedValue = device?.fw || 'Unknown'
      break
    case LAYER_NOISE: {
      formattedValue = device?.noiseEnabled ?? 'Unknown'
      break
    }
    case LAYER_MIC: {
      formattedValue = device?.hasMicrophone ?? 'Unknown'
      break
    }
    default:
      formattedValue = null
  }
  return formattedValue
}

const getLayerColor = ({ unit, device, layer, legend }) => {
  const getColor = (value) => {
    const key =
      value === null || value === undefined || value === '' ? 'UNKNOWN' : value
    return legend[layer][key]?.color
  }

  const valueProp = layerValueProps[layer] ?? null
  const unitLevelLayers = [LAYER_STATUS, LAYER_SNOOZE]

  if (device) {
    return unitLevelLayers.includes(layer)
      ? getColor(unit[valueProp])
      : getColor(device?.[valueProp])
  }

  const { devices } = unit

  if (devices.length > 1) {
    if (unitLevelLayers.includes(layer)) {
      return getColor(unit[valueProp])
    }

    const color1 = getColor(devices[0]?.[valueProp])
    const color2 = getColor(devices[1]?.[valueProp])
    return `linear-gradient(125deg, ${color1} 0%, ${color2} 100%)`
  }

  const firstDevice = unit.devices[0]
  return unitLevelLayers.includes(layer)
    ? getColor(unit[valueProp])
    : getColor(firstDevice?.[valueProp])
}

export { getLayerColor, getLayerFormattedValue }
